
        Component.define('warnings', (el, params) => {
            
        });